import type { RouteRecordRaw } from 'vue-router';

export const documentationRoutes: Array<RouteRecordRaw> = [
  {
    path: '/documentation',
    name: 'documentation',
    redirect: '/documentation/explorer',
    component: () => import('pages/central/documentation/McDocumentation.vue'),
    meta: {
      title: 'mConnect Documentations',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'documentationList',
        component: () => import('pages/central/documentation/DocumentationList.vue'),
        meta: {
          title: 'Documentations List',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'documentationExplorer',
        component: () => import('pages/central/documentation/DocumentationExplorer.vue'),
        meta: {
          title: 'mConnect Documentations Explorer',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'documentationDetail',
        component: () => import('pages/central/documentation/DocumentationDetail.vue'),
        meta: {
          title: 'Documentation Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'documentationNew',
        component: () => import('pages/central/documentation/DocumentationNew.vue'),
        meta: {
          title: 'New Documentation',
          requiresAuth: true,
        },
      },
    ],
  },
];
